import notify from 'devextreme/ui/notify';
import React, { createContext, useCallback, useContext, useEffect } from 'react';
import useWindowFocus from 'use-window-focus';
import { getItemApi, getListApi } from '../apiUtils';
import { ApplicationUser } from '../types/applicationUser.types';
import { Translation } from '../types/language.types';
import { API_URL } from '../utils/apiUrl';
import { useAuth } from './auth';
import { useTranslation } from './translation';

const WindowFocusContext = createContext<WindowFocusContextType>({});

function WindowFocusProvider(props: any) {
  const windowFocused = useWindowFocus();
  const { user } = useAuth();
  const { translateLocal } = useTranslation();

  const getCurrentUser = useCallback(async () => {
    return await getItemApi<ApplicationUser>({
      url: `${API_URL.GET_CURRENT_USER}`,
      params: {},
      hideNotifications: true,
    });
  }, []);

  const getTranslations = useCallback(async () => {
    return await getListApi<Translation>({
      url: `${API_URL.GET_TRANSLATIONS}`,
      params: {},
    });
  }, []);

  const resolveFocus = useCallback(async (_windowFocused: boolean, _user: ApplicationUser) => {
    const currentUser = await getCurrentUser();
    if (_user && currentUser && _user.personalNumber !== currentUser.personalNumber) {
      const translations = await getTranslations();
      notify(
        translateLocal!(translations!, `A new user has logged in. The page will be reloaded.`, ''),
        'error',
      );
      setTimeout(() => {
        location.reload();
      }, 1500);
    }
  }, []);

  useEffect(() => {
    if (!windowFocused || !user) return;
    resolveFocus(windowFocused, user);
  }, [windowFocused]);

  return <WindowFocusContext.Provider value={{}} {...props} />;
}

interface WindowFocusContextType {}

const useAssetClass = () => useContext<WindowFocusContextType>(WindowFocusContext);

export { WindowFocusProvider, useAssetClass };
